import { render, staticRenderFns } from "./editProgram.vue?vue&type=template&id=62856c32&"
import script from "./editProgram.vue?vue&type=script&lang=js&"
export * from "./editProgram.vue?vue&type=script&lang=js&"
import style0 from "./editProgram.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports